import React from 'react'
import SimpleCard from 'app/components/card'

// Card that holds part of report subpage content
export function ContentCard({
  title,
  children,
  style,
  className,
}: {
  title: string
  children: any
  style?: React.CSSProperties
  className?: string
}): JSX.Element {
  return (
    <SimpleCard title={title} style={style} className={'content-card ' + (className || '')}>
      <div>{children}</div>
    </SimpleCard>
  )
}
